import { Layout } from 'components/layout';
import React from 'react';

export const About = () => {
  return (
    <section className="bg-plt-secondary/50 mt-[72px] font-open-sans screen-900:mt-5">
      <Layout.Container>
        <div className="pt-10 pb-[64px] px-[33px] screen-700:px-5 screen-700:pt-6 screen-700:pb-5">
          <h3 className="uppercase font-bold text-center text-[32px] text-plt-black">
            О проекте
          </h3>
          {/* Это ужасное решение но быстро ток так */}
          <div className="mt-[65px] min-h-[560px] screen-700:min-h-[460px] screen-500:min-h-full h-full flex gap-[52px] screen-1200:grid screen-700:gap-5 screen-700:mt-5 screen-700:">
            <div className="basis-[50%] min-h-[inherit] w-full h-full overflow-hidden flex items-stretch">
              <img
                src="/assets/images/png/about.jpg"
                alt="krekshino-about"
                className="w-auto min-h-[inherit] h-full object-cover rounded-[40px] rounded-se-none screen-1200:mx-auto"
              />
            </div>
            <div className="basis-[50%]  h-full">
              <h4 className="max-w-[327px] font-semibold leading-[120%] text-xl screen-1200:text-center screen-1200:mx-auto screen-700:max-w-full">
                ЖК «Крекшино Парк» – ваш новый дом в экологически чистом районе Новой Москвы
              </h4>
              <p className="pt-[44px] font-semibold leading-[120%] screen-1200:text-center screen-1200:mx-auto screen-1200:pt-2 screen-700:max-w-full screen-700:font-normal">
                Современный жилой комплекс «Крекшино Парк» возводится в экологически чистом районе Новой
                Москвы. Три монолитных корпуса с переменной этажностью от 8 до 17 этажей органично
                вписаны в природный ландшафт. Здесь каждый найдет пространство для жизни и отдыха:
                современные детские площадки для разных возрастных групп, оборудованные спортивные зоны и
                благоустроенные дворы с большим количеством зелени. Для вашей безопасности проект имеет
                закрытую территорию с видеонаблюдением и современной системой контроля доступа.
              </p>
              <p className="pt-3 font-semibold leading-[120%] screen-1200:text-center screen-1200:mx-auto screen-1200:pt-2 screen-700:max-w-full screen-700:font-normal">
                Помимо квартир с классическими планировками, в комплексе представлены квартиры с кухней-
                гостиной, мастер-спальнями, гардеробными, а также со вторым светом и собственным входом.
              </p>
              <p className="pt-3 font-semibold leading-[120%] screen-1200:text-center screen-1200:mx-auto screen-1200:pt-2 screen-700:max-w-full screen-700:font-normal">
                Подземный паркинг обеспечит удобное хранение вашего автомобиля, а келлеры помогут
                освободить пространство. На 1-м этаже откроются коммерческие помещения, а необходимые
                объекты инфраструктуры находятся на расстоянии не более 500 метров.
              </p>
              <p className="pt-3 font-semibold leading-[120%] screen-1200:text-center screen-1200:mx-auto screen-1200:pt-2 screen-700:max-w-full screen-700:font-normal">
                ЖК «Крекшино Парк» – это пространство, где современный городской комфорт гармонично
                сочетается с природной тишиной и спокойствием Новой Москвы. Здесь каждая деталь создана для
                вашего удобства и безопасности, а продуманные планировки позволяют воплотить любые
                дизайнерские решения.
              </p>
            </div>
          </div>
        </div>
      </Layout.Container>
    </section>
  );
};
